var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "app-wrapper",
        _vm.hide || _vm.NODE_ENV === "erp-prod" ? "w100" : "",
      ],
      style: "" + (_vm.hide ? "min-width: unset" : ""),
    },
    [
      !_vm.hide && !(_vm.$route.query.token || _vm.hasToken)
        ? _c("nav-top")
        : _vm._e(),
      _vm.$route.query.token || _vm.hasToken ? _c("erpnavtop") : _vm._e(),
      _c(
        "div",
        {
          staticClass: "con",
          class: { hide: _vm.hide || this.$route.query.hide },
        },
        [
          _c(
            "div",
            {
              staticClass: "main-container",
              class: { hide: _vm.hide || this.$route.query.hide },
            },
            [
              _c("menubar", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.hide,
                    expression: "!hide",
                  },
                ],
              }),
              _c("three-level-view"),
            ],
            1
          ),
        ]
      ),
      _c("callFixed", { ref: "callFixed" }),
      _c("companyReport", {
        staticStyle: { margin: "0" },
        attrs: { showBtn: false },
      }),
      !_vm.subscribeMsg
        ? _c("subscribe-info-push", { ref: "subscribeInfoPush" })
        : _vm._e(),
      _c("batch-unlock-tip", { ref: "batchUnlockTip" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }